// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Modal0 from "../common/Modal0.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Search2 from "../common/Search2.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as AugmentName from "common/src/tft-static/AugmentName.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as SearchField2 from "../components/SearchField2.bs.js";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as Belt_SetString from "rescript/lib/es6/belt_SetString.js";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import PriorityHigh from "@mui/icons-material/PriorityHigh";

function renderStagePlace(v) {
  if (v === undefined) {
    return "—";
  }
  var place = v[1];
  var count = v[0];
  if (count < 10 || place > 7.5) {
    return "—";
  } else if (count < 100) {
    return React.createElement("div", {
                className: "flex text-white2 items-center"
              }, React.createElement(PriorityHigh, {
                    fontSize: "inherit",
                    color: "inherit"
                  }), Global.toFixed(undefined, place));
  } else {
    return Global.toFixed(undefined, place);
  }
}

function renderStageTooltip(v, globalCount, stage) {
  if (v === undefined) {
    return "Augment not offered at this stage";
  }
  var place = v[1];
  var count = v[0];
  if (count < 10 || place > 7.5) {
    return "Augment not offered at this stage";
  }
  if (count < 100) {
    var tmp;
    switch (stage) {
      case /* S21 */0 :
          tmp = "1st";
          break;
      case /* S32 */1 :
          tmp = "2nd";
          break;
      case /* S42 */2 :
          tmp = "3rd";
          break;
      
    }
    var tmp$1;
    switch (stage) {
      case /* S21 */0 :
          tmp$1 = "2-1";
          break;
      case /* S32 */1 :
          tmp$1 = "3-2";
          break;
      case /* S42 */2 :
          tmp$1 = "4-2";
          break;
      
    }
    return React.createElement("div", undefined, React.createElement("div", {
                    className: "flex items-center pb-1"
                  }, React.createElement(PriorityHigh, {
                        fontSize: "inherit"
                      }), "Very low sample size"), Global.toFixed(3, Global.f(count) / Global.f(globalCount) * 8) + " pickrate (" + T.humanReadableCount(count) + " games) and " + Global.toFixed(undefined, place) + " avg. place when picked as " + tmp + " augment (stage " + tmp$1 + ")");
  }
  var tmp$2;
  switch (stage) {
    case /* S21 */0 :
        tmp$2 = "1st";
        break;
    case /* S32 */1 :
        tmp$2 = "2nd";
        break;
    case /* S42 */2 :
        tmp$2 = "3rd";
        break;
    
  }
  var tmp$3;
  switch (stage) {
    case /* S21 */0 :
        tmp$3 = "2-1";
        break;
    case /* S32 */1 :
        tmp$3 = "3-2";
        break;
    case /* S42 */2 :
        tmp$3 = "4-2";
        break;
    
  }
  return Global.toFixed(3, Global.f(count) / Global.f(globalCount) * 8) + " pickrate (" + T.humanReadableCount(count) + " games) and " + Global.toFixed(undefined, place) + " avg. place when picked as " + tmp$2 + " augment (stage " + tmp$3 + ")";
}

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Augment");
        }), "!pl-6", (function (v, param, param$1) {
          var info = Data.augmentInfo(v.id, param$1.set);
          var match = Belt_Option.flatMap(info, (function (v) {
                  return v.hero;
                }));
          return React.createElement(React.Fragment, undefined, React.createElement(AugmentImage.make, {
                          augId: v.id,
                          size: 28
                        }), React.createElement("div", {
                          className: "pl-[6px] font-roboto font-normal truncate"
                        }, match !== undefined ? "[" + param$1.unitsT(match[0]) + "] " : null, React.createElement(AugmentName.make, {
                              id: v.id
                            })));
        }), "!pl-6", undefined, undefined, (function (v, param, param$1) {
          return param$1.augmentsT(v.id);
        }), undefined, 200, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Games");
        }), undefined, (function (v, param, param$1) {
          return T.humanReadableCount(v.count);
        }), undefined, (function (v, param, param$1) {
          return Global.toFixed(3, Global.f(v.count) / Global.f(param[0]) * 8) + "/8 pick rate";
        }), undefined, (function (v, param, param$1) {
          return v.count;
        }), undefined, 84, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixed(undefined, v.avgPlace);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.avgPlace;
        }), undefined, 72, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("At 2-1");
        }), undefined, (function (v, param, param$1) {
          return renderStagePlace(v.p1);
        }), undefined, (function (v, param, param$1) {
          return renderStageTooltip(v.p1, param[0], /* S21 */0);
        }), undefined, (function (v, param, param$1) {
          return Belt_Option.flatMap(v.p1, (function (param) {
                        if (param[0] < 10) {
                          return ;
                        } else {
                          return param[1];
                        }
                      }));
        }), undefined, 74, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("At 3-2");
        }), undefined, (function (v, param, param$1) {
          return renderStagePlace(v.p2);
        }), undefined, (function (v, param, param$1) {
          return renderStageTooltip(v.p2, param[0], /* S32 */1);
        }), undefined, (function (v, param, param$1) {
          return Belt_Option.flatMap(v.p2, (function (param) {
                        if (param[0] < 10) {
                          return ;
                        } else {
                          return param[1];
                        }
                      }));
        }), undefined, 74, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("At 4-2");
        }), "!pr-6", (function (v, param, param$1) {
          return renderStagePlace(v.p3);
        }), "!pr-6", (function (v, param, param$1) {
          return renderStageTooltip(v.p3, param[0], /* S42 */2);
        }), undefined, (function (v, param, param$1) {
          return Belt_Option.flatMap(v.p3, (function (param) {
                        if (param[0] < 10) {
                          return ;
                        } else {
                          return param[1];
                        }
                      }));
        }), undefined, 78, undefined, undefined)
];

function Tc2AugmentsTab2$SinglesList(Props) {
  var augsData = Props.augsData;
  var globalCount = Props.globalCount;
  var showSilverAugs = Props.showSilverAugs;
  var showGoldAugs = Props.showGoldAugs;
  var showPrismAugs = Props.showPrismAugs;
  var search = Props.search;
  var set = TftSet.use(undefined);
  ScreenAtom.use(undefined);
  var aperture = ApertureCtx.useValue(undefined);
  var keyFn = React.useCallback((function (aug) {
          return aug.id;
        }), []);
  var context = React.useMemo((function () {
          return [
                  globalCount,
                  aperture
                ];
        }), [
        globalCount,
        aperture
      ]);
  Translation.useT(/* Augments */4);
  Translation.useT(/* Units */1);
  var searchIds = React.useMemo((function () {
          if (search === "") {
            return ;
          } else {
            return Caml_option.some(Belt_SetString.fromArray(Search2.searchAugmentsArr(search, set)));
          }
        }), [search]);
  var visibleFilter = React.useCallback((function (aug) {
          var showAllTiers = showSilverAugs && showGoldAugs && showPrismAugs || !showSilverAugs && !showGoldAugs && !showPrismAugs;
          var augPass;
          if (showAllTiers) {
            augPass = true;
          } else {
            var info = Data.augmentInfoExn(aug.id, set);
            var match = info.rank;
            switch (match) {
              case 1 :
                  augPass = showSilverAugs;
                  break;
              case 2 :
                  augPass = showGoldAugs;
                  break;
              case 3 :
                  augPass = showPrismAugs;
                  break;
              default:
                augPass = false;
            }
          }
          var searchPass = searchIds !== undefined ? Belt_SetString.has(Caml_option.valFromOption(searchIds), aug.id) : true;
          if (augPass) {
            return searchPass;
          } else {
            return false;
          }
        }), [
        search,
        showSilverAugs,
        showGoldAugs,
        showPrismAugs
      ]);
  return React.createElement("div", {
              className: "mx-[-20px]"
            }, React.createElement(StatsTable2.make, {
                  cols: cols,
                  data: augsData,
                  context: context,
                  keyFn: keyFn,
                  stickyColCount: 1,
                  top: "tm40",
                  defaultSortIdx: 1,
                  visibleFilter: visibleFilter,
                  lazyInit: false,
                  scrollEl: [
                    Modal0.modalScrollEl(),
                    0
                  ]
                }));
}

var make = React.memo(Tc2AugmentsTab2$SinglesList);

var SinglesList = {
  renderStagePlace: renderStagePlace,
  renderStageTooltip: renderStageTooltip,
  cols: cols,
  make: make
};

function Tc2AugmentsTab2(Props) {
  var augmentSingles = Props.augmentSingles;
  var aug1s = Props.aug1s;
  var aug2s = Props.aug2s;
  var aug3s = Props.aug3s;
  var groupCount = Props.groupCount;
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return "";
      });
  var search = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowSilverAugs = match$1[1];
  var showSilverAugs = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setShowGoldAugs = match$2[1];
  var showGoldAugs = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setShowPrismAugs = match$3[1];
  var showPrismAugs = match$3[0];
  var data = React.useMemo((function () {
          var p1 = Belt_MapString.fromArray(Belt_Array.map(aug1s, (function (param) {
                      return [
                              param[0],
                              [
                                param[1],
                                param[2]
                              ]
                            ];
                    })));
          var p2 = Belt_MapString.fromArray(Belt_Array.map(aug2s, (function (param) {
                      return [
                              param[0],
                              [
                                param[1],
                                param[2]
                              ]
                            ];
                    })));
          var p3 = Belt_MapString.fromArray(Belt_Array.map(aug3s, (function (param) {
                      return [
                              param[0],
                              [
                                param[1],
                                param[2]
                              ]
                            ];
                    })));
          return Belt_Array.map(augmentSingles, (function (param) {
                        var id = param[0];
                        return {
                                id: id,
                                count: param[1],
                                avgPlace: param[2],
                                p1: Belt_MapString.get(p1, id),
                                p2: Belt_MapString.get(p2, id),
                                p3: Belt_MapString.get(p3, id)
                              };
                      }));
        }), [
        augmentSingles,
        aug1s,
        aug2s,
        aug3s
      ]);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex flex-col sm:flex-row justify-between gap-1"
                }, React.createElement("div", {
                      className: "pl-4 w-[200px]"
                    }, React.createElement(SearchField2.make, {
                          search: search,
                          setSearch: match[1]
                        })), React.createElement("div", {
                      className: "flex pl-2 select-none"
                    }, React.createElement(FormControlLabel, {
                          control: React.createElement(Checkbox, {
                                checked: showSilverAugs,
                                onChange: (function (e) {
                                    var checked = e.target.checked;
                                    return Curry._1(setShowSilverAugs, (function (param) {
                                                  return checked;
                                                }));
                                  }),
                                color: "primary",
                                size: "small"
                              }),
                          label: t("Silver")
                        }), React.createElement("div", {
                          className: "px-2"
                        }, React.createElement(FormControlLabel, {
                              control: React.createElement(Checkbox, {
                                    checked: showGoldAugs,
                                    onChange: (function (e) {
                                        var checked = e.target.checked;
                                        return Curry._1(setShowGoldAugs, (function (param) {
                                                      return checked;
                                                    }));
                                      }),
                                    color: "primary",
                                    size: "small"
                                  }),
                              label: t("Gold")
                            })), React.createElement(FormControlLabel, {
                          control: React.createElement(Checkbox, {
                                checked: showPrismAugs,
                                onChange: (function (e) {
                                    var checked = e.target.checked;
                                    return Curry._1(setShowPrismAugs, (function (param) {
                                                  return checked;
                                                }));
                                  }),
                                color: "primary",
                                size: "small"
                              }),
                          label: t("Prismatic")
                        }))), React.createElement(make, {
                  augsData: data,
                  globalCount: groupCount,
                  showSilverAugs: showSilverAugs,
                  showGoldAugs: showGoldAugs,
                  showPrismAugs: showPrismAugs,
                  search: search
                }));
}

var make$1 = Tc2AugmentsTab2;

export {
  SinglesList ,
  make$1 as make,
  
}
/* cols Not a pure module */
